export const alphabets = [
    "nwxghyzapqrstbcfouvijklmde",
    "pqrsnfouviwcjklyzatbmdexgh",
    "bcfouvijklmdenwxghyzapqrst",
    "jklyzatbmdexghpqrsnfouviwc",
    "lzapqdghjkyirstbenwxcfouvm",
    "snfouptbmdqrvjklyzaexghiwc",
    "niwcjklyexghpqrszatbmdfouv",
    "qrscjklyezatbmdfouvniwxghp",
    "xghyzapqrbjklmdenwstcfouvi",
    "mdouptqryzaexghiwcsnfbvjkl",
    "jklzapqrstbenwxcfouvmdghyi",
    "nwbcfouvijxghyzapqrstklmde",
    "mdexghjklpouviwcqrsnfyzatb",
    "bcfouvijklmdenwxghyzapqrst",
    "jklyzatbmdexghpqrsnfouviwc",
    "yenwxcfirstbouvmlzapqdghjk",
    "qrvjiwcsnfouptbmdklyzaexgh",


 ];